import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export const ChapterTag = ({ number, label, dark = false }) => (
  <div className="flex items-center gap-3" data-testid={`chapter-tag-${number}`}>
    <span className="text-sm font-black text-[#F3802A]">{number}</span>
    <span className="h-px w-10 bg-[#F3802A]" aria-hidden="true" />
    <span
      className={`text-sm font-extrabold uppercase tracking-[0.22em] ${
        dark ? "text-[#EADCC6]" : "text-[#115B5B]"
      }`}
    >
      {label}
    </span>
  </div>
);
